import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=a546849c&scoped=true&"
import script from "./CompanyDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=a546849c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a546849c",
  null
  
)

export default component.exports